import {
    DetailsFieldsCard,
    DetailsFieldsSection,
    DetailsPlannedAccessEmptyState
} from '@/components/ui/details-atoms/DetailsAtoms'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {Trans, useTranslation} from 'react-i18next'
import {PlusIcon} from '@/components/ui/icon/Icon'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {routes} from '@/utilities/constants/routes'
import {generatePath, useOutletContext} from 'react-router-dom'
import {ProjectExtended} from '../../types'
interface PlannedAccessEmptyCardProps {
    isLoading: boolean
}

export const PlannedAccessEmptyCard = ({isLoading}: PlannedAccessEmptyCardProps) => {
    const {t} = useTranslation()
    const {project} = useOutletContext<{project: ProjectExtended}>()

    if (isLoading) {
        return (
            <DetailsFieldsSection
                variant="neutral"
                infoTitleSlot={<Skeleton width={108} height={24} />}
                title={t('projects:planned_accesses')}
                width="100%"
                height="100%"
                headingEndSlot={
                    <Flexbox gap={1}>
                        <Skeleton width={100} height={32} />
                        <Skeleton width={100} height={32} />
                    </Flexbox>
                }
            >
                <Flexbox direction="column" gap={4} fullWidth>
                    <Skeleton width={200} height={20} />

                    <Flexbox direction="column" gap={1} fullWidth>
                        <Grid columns={3} fullWidth>
                            <GridItem spanColumn={2}>
                                <Skeleton width={100} height={20} />
                            </GridItem>
                            <GridItem>
                                <Skeleton width={30} height={20} />
                            </GridItem>
                        </Grid>
                        <DetailsFieldsCard size="sm" fullWidth gap={2} direction="column">
                            {Array.from({length: 3}).map((_, index) => (
                                <Grid columns={3} gap={1} fullWidth key={index}>
                                    <Skeleton width={170} height={20} />
                                    <Skeleton width={120} height={20} />
                                    <Skeleton width={30} height={20} />
                                </Grid>
                            ))}
                        </DetailsFieldsCard>
                    </Flexbox>

                    <Flexbox direction="column" gap={1} fullWidth>
                        <Grid columns={3} fullWidth>
                            <GridItem spanColumn={2}>
                                <Skeleton width={100} height={20} />
                            </GridItem>
                            <GridItem>
                                <Skeleton width={30} height={20} />
                            </GridItem>
                        </Grid>
                        <DetailsFieldsCard size="sm" fullWidth gap={2} direction="column">
                            {Array.from({length: 3}).map((_, index) => (
                                <Grid columns={3} gap={1} fullWidth key={index}>
                                    <GridItem spanColumn={2}>
                                        <Skeleton width={170} height={20} />
                                    </GridItem>
                                    <GridItem>
                                        <Skeleton width={30} height={20} />
                                    </GridItem>
                                </Grid>
                            ))}
                        </DetailsFieldsCard>
                    </Flexbox>

                    <Skeleton width={200} height={20} />

                    <Flexbox direction="column" gap={1} fullWidth>
                        <Grid columns={3} fullWidth>
                            <GridItem spanColumn={2}>
                                <Skeleton width={100} height={20} />
                            </GridItem>
                            <GridItem>
                                <Skeleton width={30} height={20} />
                            </GridItem>
                        </Grid>
                        <DetailsFieldsCard size="sm" fullWidth gap={2} direction="column">
                            {Array.from({length: 3}).map((_, index) => (
                                <Grid columns={3} gap={1} fullWidth key={index}>
                                    <GridItem spanColumn={2}>
                                        <Skeleton width={170} height={20} />
                                    </GridItem>
                                    <GridItem>
                                        <Skeleton width={30} height={20} />
                                    </GridItem>
                                </Grid>
                            ))}
                        </DetailsFieldsCard>
                    </Flexbox>
                </Flexbox>
            </DetailsFieldsSection>
        )
    }

    return (
        <DetailsFieldsSection
            infoTitleSlot={
                <Text size="textLg">
                    <Trans i18nKey="projects:x_total_accesses" values={{value: '-'}} />
                </Text>
            }
            variant="neutral"
            title={t('projects:planned_accesses')}
            width="100%"
            height="100%"
        >
            <Flexbox direction="column" gap={4} fullWidth>
                <Text palette="neutral" shade="950" weight="500" size="textSm">
                    <Trans i18nKey="projects:patient_presence_count" values={{value: '-'}} />
                </Text>

                <DetailsPlannedAccessEmptyState
                    variant="secondary"
                    title={t('projects:no_planned_accesses')}
                    subtitle={t('projects:no_planned_accesses_description')}
                >
                    <ButtonLink
                        to={generatePath(routes.CREATE_PLANNED_ACCESSES.path, {id: project.id})}
                        variant="primaryNeutral"
                    >
                        <PlusIcon />
                        {t('projects:planned_accesses')}
                    </ButtonLink>
                </DetailsPlannedAccessEmptyState>

                <Text palette="neutral" shade="950" weight="500" size="textSm">
                    <Trans i18nKey="projects:patient_absence_count" values={{total: '-', percentage: 0}} />
                </Text>
            </Flexbox>
        </DetailsFieldsSection>
    )
}
